import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { quoteAuthHeaders } from './quote-token.js'

/** « Je souhaite recevoir un devis similaire », depuis une proposition expirée. */
export const useRequestPublicQuoteSimilarMutation = () =>
  useMutation({
    mutationFn: async (responseId: string) => {
      const response = await apiClient.client.post(
        `/public/estimate-responses/${responseId}/similar-request`,
        undefined,
        { headers: quoteAuthHeaders(responseId) }
      )
      return response.data
    },
  })
